<div class="request-sent-container">
    <span class="request-sent-title">{{'requests.wizard.requestSentTitle' | translate}}</span>
    <span class="request-sent-subtitle">
        <span>{{'requests.wizard.requestSentSubtitle1' | translate}}</span>
        <span class="text-primary fw-bold cursor-pointer" (click)="navigateToListHandler()">
            {{'requests.wizard.requestSentSubtitle2' | translate}}
        </span>
        <span>{{'requests.wizard.requestSentSubtitle3.contractModifications' | translate}}</span>
    </span>
    <request-sent-placeholder class="mt-5"></request-sent-placeholder>
</div>